import React from 'react';
import styled from 'styled-components';

import Typography from '../../components/common/Typography';
import { IconButton } from '../../components/common/Button';

const FileCardStyled = styled.div`
  display: flex;
  gap: 8px;
  padding: 10px 15px;
  border-radius: 10px;
  background: var(--GrayScale-100);
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const EvidenceFileCard = ({ fileName, fileSize, htmRegDate = '', fileType, onDelete, onClick }) => {
  return (
    <FileCardStyled>
      <ContentWrapper>
        <FileInfo onClick={onClick}>
          <Typography variant="body2Bold">{fileName}</Typography>
          <div className="displayFlex" style={{ gap: '10px' }}>
            <Typography variant="captionMedium">{htmRegDate}</Typography>
            <Typography variant="captionMedium">{fileType}</Typography>
            <Typography variant="captionMedium">{fileSize}</Typography>
          </div>
        </FileInfo>
        <IconButton
          deleteIcon
          variant="outline"
          size="small"
          color="gray"
          onClick={onDelete}
          alt={`${fileName} 삭제`}
        />
      </ContentWrapper>
    </FileCardStyled>
  );
};

export default EvidenceFileCard;
